<script lang="ts" setup>
const emit = defineEmits(['share'])
const props = defineProps<{ noIcon?: boolean }>()

const { t } = useI18n()
const theme = useStoreTheme()
</script>

<template>
  <button
    class="flex w-full items-center justify-center rounded-full border-1 border-solid px-6 py-4 text-sm font-semibold uppercase md:text-base"
    :style="{
      borderColor: theme.primary,
      color: theme.primary,
    }"
    @click="emit('share')"
  >
    <div class="flex items-center justify-center gap-2">
      <RIcon v-if="!props.noIcon" size="24" name="ic:outline-share"></RIcon>
      {{ t('components.shareButton.label') }}
    </div>
  </button>
</template>
